import './style.scss';
import {initArchiveFilterSearch} from "../../scripts/archive-filter-search";

export function product_archive_block() {
    initArchiveFilterSearch({
        root: '.product_archive_block',
        counterInputsSelector: [
            'input[type="checkbox"][name="product-type[]"]',
            'input[type="checkbox"][name="make[]"]',
            'input[type="checkbox"][name="product-category[]"]',
        ].join(', '),
    });
}
